import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// Initializes Sentry once at app startup (called from src/index.tsx before the
// React tree is rendered). Mirrors the init pattern used across hssoft services
// (see console-hssoft-com-service-mono `src/shared/sentry.ts`): DSN-driven,
// enabled only in production, scoped per environment, with a modest trace
// sample rate.
export function initSentry() {
  const appEnv = process.env.REACT_APP_ENV || 'production';
  // Only report from the production build. Other envs → SDK is inert (no-ops).
  const enabled = appEnv === 'production';

  Sentry.init({
    dsn: 'https://d974735b1865adc3bca8b4cadaa5ff3a@o4504242163613696.ingest.us.sentry.io/4511569998577664',
    enabled,
    environment: appEnv,
    // Ties events to a release for tracking (REACT_APP_VERSION is injected at
    // build time by the `inject-version` npm script).
    release: process.env.REACT_APP_VERSION,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
  });
}

export { Sentry };
